<template lang="pug">
v-theme-provider(:theme="dark ? 'dark' : 'light'")
  v-container(no-gutter)
    v-row(no-gutters, justify='center')
      v-col(justify='center', align='center', cols='12')
        base-img(
          :src='logoSrc',
          contain='',
          max-width='128',
          min-height='78',
          width='100%'
        )
    v-row(no-gutters)
      v-col(cols='12', align='center')
        p.text-center.px-3.text-caption
          | {{ t('info.body') }}
</template>

<script setup>
defineOptions({
  name: 'BaseInfo',
})
const props = defineProps({
  title: { type: String, default: '' },
  dark: Boolean,
})

const logoSrc = '/media/brand/EoT_short_white.svg'
const { t } = useI18n()
</script>
